import React from "react"
import BlockWrapper from "../technical/BlockWrapper"
import Headline from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Headline"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"
import { Chat32, Email32, Map32 } from "@carbon/icons-react"

import { useTranslation } from "react-i18next"
import Button from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Button"

const ProductServiceInfoBlock = () => {
  const { i18n, ready } = useTranslation("translations", { useSuspense: false })
  const block = i18n.t("generic.product_service", {
    returnObjects: true,
  })
  if (ready === false) return null
  if (typeof block === "string") return null

  return (
    <BlockWrapper
      block={block}
      className="bg-gray-100"
      blockPadding="py-16"
      showHeadline="false"
    >
      <div className="w-full text-center">
        <Headline
          headline={block.headline}
          headlineLevel="h2"
          className="mb-10"
        />
      </div>
      <div className="flex flex-row flex-wrap -mb-8 -mx-grid justify-center">
        <div className="w-full h-auto mb-8 md:w-1/2 lg:w-1/3 px-grid">
          <div className="h-full px-4 py-6 bg-white">
            <div className="flex flex-col justify-between h-full">
              <div>
                <div className="pb-2 text-primary">
                  <Chat32 />
                </div>
                <Headline
                  headline={block.contact.headline}
                  headlineLevel="h3"
                />
                <Richtext text={block.contact.text} />
              </div>
            </div>
          </div>
        </div>
        <div className="w-full h-auto mb-8 md:w-1/2 lg:w-1/3 px-grid">
          <div className="h-full px-4 py-6 bg-white">
            <div className="flex flex-col justify-between h-full">
              <div>
                <div className="pb-2 text-primary">
                  <Email32 />
                </div>
                <Headline
                  headline={block.complaint.headline}
                  headlineLevel="h3"
                />
                <Richtext text={block.complaint.text} />
              </div>
              <Button className="mt-4 text-center" link={block.complaint.link}>
                {block.complaint.link_text}
              </Button>
            </div>
          </div>
        </div>
        <div className="w-full h-auto mb-8 md:w-1/2 lg:w-1/3 px-grid">
          <div className="h-full px-4 py-6 bg-white">
            <div className="flex flex-col justify-between h-full">
              <div>
                <div className="pb-2 text-primary">
                  <Map32 />
                </div>
                <div>
                  <Headline
                    headline={block.dealer.headline}
                    headlineLevel="h3"
                  />
                  <Richtext text={block.dealer.text} />
                </div>
              </div>
              <Button className="mt-4 text-center" link={block.dealer.link}>
                {block.dealer.link_text}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </BlockWrapper>
  )
}

export default ProductServiceInfoBlock
